import { Box, DarkMode, Heading, Link, Stack } from '@chakra-ui/react';
import { memo } from 'react';
import { navScrollbar } from 'shared-components';
import { ThemeSwitcher } from '../../atoms/ThemeSwitcher';
import { UniLogo } from '../../atoms/uni-logo';
import Footer from '../Footer';
import NavButton from './NavButton';
import { ISectionProps, ISidebarContentsProps } from './types';

const SidebarContents = ({
  student_name,
  student_number,
  sections,
  activeSectionId,
  onLogout,
  onSectionSelect,
  onClose,
  navigationUrls,
  hasApplyAccess,
  importData
}: ISidebarContentsProps) => {
  return (
    <Box
      as="nav"
      display="flex"
      height="100%"
      position="relative"
      flexDirection="column"
      color="whiteAlpha.800"
      bgColor="utility.900"
      _dark={{ bgColor: 'gray.800' }}
    >
      <DarkMode>
        <Link href="/" display="block" mx="auto" px={4} py={4} maxWidth="16rem">
          <UniLogo />
        </Link>

        <Stack
          spacing={0}
          flexDirection="column"
          overflowY="auto"
          flexGrow="1"
          sx={{
            ...navScrollbar,
            scrollbarGutter: 'stable'
          }}
        >
          <Heading as="h3" fontSize="2xl" mx={8} textAlign="center">
            Hello {student_name}
          </Heading>

          <Stack spacing={0} flexGrow="1" px={4} py={6}>
            {(sections || []).map((section: ISectionProps) => (
              <NavButton
                key={section.id}
                {...section}
                onSectionSelect={onSectionSelect}
                clickable={section.clickable}
                isActive={section.id === activeSectionId}
                onClose={onClose}
              />
            ))}
          </Stack>

          <Footer
            onLogout={onLogout}
            student_number={student_number}
            applyUrl={importData?.applicantId ? navigationUrls?.apply : null}
            hasApplyAccess={hasApplyAccess}
          />
        </Stack>
      </DarkMode>

      <ThemeSwitcher />
    </Box>
  );
};

export default memo(SidebarContents);
